
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18515 -2643 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 6567","transform":"translate(-19268 -3340)"}},[_c('circle',{attrs:{"cx":"8.5","cy":"8.5","r":"8.5","data-name":"Ellipse 908","transform":"translate(753 697)","fill":"#3684b9"}}),_c('g',{attrs:{"data-name":"Group 6567"}},[_c('path',{attrs:{"d":"M761.878 700.136a1.294 1.294 0 1 1-1.294 1.294 1.294 1.294 0 0 1 1.294-1.294z","fill":"#fff"}}),_c('path',{attrs:{"d":"M759 705.129l2.006-1.14a.55.55 0 0 1 .817.594l-1.535 5.225a.559.559 0 0 0 .817.594l1.882-1.114","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.4"}})])])])
          )
        }
      }
    